import furniture1 from "../images/furniture/furniture1.png";
import furniture2 from "../images/furniture/furniture2.png";
import furniture3 from "../images/furniture/furniture3.png";
import furniture4 from "../images/furniture/furniture4.png";
import furniture5 from "../images/furniture/furniture5.png";
import furniture6 from "../images/furniture/furniture6.png";
import furniture7 from "../images/furniture/furniture7.png";
import furniture8 from "../images/furniture/furniture8.png";
import furniture9 from "../images/furniture/furniture9.png";
import furniture10 from "../images/furniture/furniture10.png";
import furniture11 from "../images/furniture/furniture11.png";
import furniture12 from "../images/furniture/furniture12.png";

const furniture = [
  {
    category: "furniture",
    id: "furniture1",
    name: "Ultra Lite Chair",
    price: 70.00,
    image: `${furniture1}`,
  },
  {
    category: "furniture",
    id: "furniture2",
    name: "Ultra Lite Highback Chair",
    price: 92.00,
    image: `${furniture2}`,
  },
  {
    category: "furniture",
    id: "furniture3",
    name: "Stargaze Luxury 2.0 Chair",
    price: 319.00,
    image: `${furniture3}`,
  },
  {
    category: "furniture",
    id: "furniture4",
    name: "Moonlite Reclining Chair",
    price: 219.00,
    image: `${furniture4}`,
  },
  {
    category: "furniture",
    id: "furniture5",
    name: "Big Agnes Big Six Arm Chair",
    price: 319.00,
    image: `${furniture5}`,
  },
  {
    category: "furniture",
    id: "furniture6",
    name: "Nemo Moonlander Table",
    price: 219.00,
    image: `${furniture6}`,
  },
  {
    category: "furniture",
    id: "furniture7",
    name: "Kelty Deluxe Lounge Chair",
    price: 82.00,
    image: `${furniture7}`,
  },
  {
    category: "furniture",
    id: "furniture8",
    name: "Skyline Ultralight Stool",
    price: 129.00,
    image: `${furniture8}`,
  },
  {
    category: "furniture",
    id: "furniture9",
    name: "Seat Cushion",
    price: 19.00,
    image: `${furniture9}`,
  },
  {
    category: "furniture",
    id: "furniture10",
    name: "Puffy Blanket 1-Person",
    price: 129.00,
    image: `${furniture10}`,
  },
  {
    category: "furniture",
    id: "furniture11",
    name: "Roo Double Hammock",
    price: 120.00,
    image: `${furniture11}`,
  },
  {
    category: "furniture",
    id: "furniture12",
    name: "Helinox Sunset Chair",
    price: 229.00,
    image: `${furniture12}`,
  },
];

export default furniture;
